import { useTranslation } from 'react-i18next';

export const useEta = (eta?: number, milliseconds: boolean = false): string => {
  const { t } = useTranslation('common');

  if (!eta) {
    return '';
  }

  const etaInMs = !milliseconds ? Number(eta) * 1000 : Number(eta);
  return `${Math.round(etaInMs / 60000)} ${t('common.minutes')}`;
};
